import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const saveShipmentView = {
  name: "saveShipmentView" as const,
  input: z.object({
    view: viewSchemas.shipments,
  }),
  output: z.object({}),
};
